import { TLink } from "@/components/molecules/Button";
import { faHouse } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import breadCrumbStyles from "./Breadcrumb.module.scss"; // icons

export const BreadCrumb = ({ lists }) => {
  return (
    <ul
      className="
      mb-4
      flex
      flex-nowrap
      items-center
      justify-start
      overflow-x-scroll
      py-2
      px-6
      fluid-text-[12px,14px]
      md:mb-0
      md:justify-end
      md:overflow-auto
      md:px-10
      md:pt-4
      md:pb-0"
      aria-label="breadcrumb"
    >
      <li className="mr-2 font-bold text-icn">
        <FontAwesomeIcon icon={faHouse} />
      </li>
      {lists.map(({ name = "Home", path = "/" }, index) => (
        <li
          className={
            (`${breadCrumbStyles.item}`,
            "font-bold flex text-txt-light mr-2 after:ml-2 after:text-sm after:content-['／'] last:mr-0 last:after:content-none text-ellipsis whitespace-nowrap")
          }
          key={index}
        >
          {lists.length - 1 !== index ? (
            <TLink
              href={path}
              variant="mono"
              color="p"
              className="font-bold text-txt-light"
            >
              {name}
            </TLink>
          ) : (
            <span aria-current="page">{name}</span>
          )}
        </li>
      ))}
    </ul>
  );
};
